import classNames from 'classnames';
import { FC, useState } from 'react';

export const ColorGrid: FC<{
  selectedColors: (string | null)[];
  onDrop: (index: number) => void;
  onDoubleClick: (index: number) => void;
  onDragOver: (e: React.DragEvent) => void;
  hoverIndex: number | null;
  setHoverIndex: (i: number | null) => void;
}> = ({ selectedColors, onDrop, onDoubleClick, onDragOver, hoverIndex, setHoverIndex }) => {
  const [hoveredCardIndex, setHoveredCardIndex] = useState<number | null>(null);
  const [tooltipPos, setTooltipPos] = useState<{ x: number; y: number } | null>(null);

  const handleMouseMove = (e: React.MouseEvent, i: number) => {
    if (hoveredCardIndex === i) {
      setTooltipPos({ x: e.clientX + 20, y: e.clientY - 10 });
    }
  };

  return (
    <div className="relative grid grid-cols-4 grid-rows-2 gap-[12px] mb-6 w-full">
      {selectedColors.map((color, i) => (
        <div
          key={i}
          onDrop={() => onDrop(i)}
          onDragOver={onDragOver}
          onDragEnter={() => setHoverIndex(i)}
          onDragLeave={(e) => {
            const current = e.currentTarget as HTMLElement;
            const related = e.relatedTarget as HTMLElement | null;
            if (!related || !current.contains(related)) {
              setHoverIndex(null);
            }
            setHoveredCardIndex((prev) => (prev === i ? null : prev));
            setTooltipPos(null);
          }}
          onMouseEnter={() => {
            if (color) setHoveredCardIndex(i);
          }}
          onMouseMove={(e) => handleMouseMove(e, i)}
          onMouseLeave={() => {
            setHoveredCardIndex(null);
            setTooltipPos(null);
          }}
          onDoubleClick={() => onDoubleClick(i)}
          className={classNames(
            'relative w-full h-[110px] lg:h-[204px] flex items-center justify-center rounded-control text-heading-lg transition-colors duration-150 cursor-pointer',
            {
              'border-2 border-ink-subtle': !color,
              'border-none': !!color,
              'bg-ink-muted': hoverIndex === i && !color,
              'bg-transparent': !color && hoverIndex !== i,
            },
          )}
          style={{
            backgroundColor: color || (hoverIndex === i ? '#424346' : 'transparent'),
          }}
        >
          {!color && <span className="pointer-events-none text-display-xl text-white/80 select-none">{i + 1}</span>}
        </div>
      ))}

      {hoveredCardIndex !== null && tooltipPos && (
        <div
          className="fixed bg-ink text-white text-ui-xs-strong rounded-control shadow-popup pointer-events-none z-50 transition-all duration-150 opacity-100 leading-tight text-left"
          style={{
            top: tooltipPos.y,
            left: tooltipPos.x,
            transform: 'translateY(-50%)',
            width: '170px',
            height: '40px',
            whiteSpace: 'normal',
            padding: '8px 12px',
          }}
        >
          Для удаления карточки нажмите дважды
        </div>
      )}
    </div>
  );
};
